import { Link } from "react-router-dom";
import { getAllVideos } from "@/lib/videoService";

const highlights = [
  {
    icon: "ri-layout-grid-line",
    title: "清晰分类",
    desc: "电影、电视剧、动漫三大频道，题材地域一目了然，快速找到想看的内容。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维筛选",
    desc: "按地域、年份、题材组合筛选，配合最新与最热排序，高效定位目标影片。",
  },
  {
    icon: "ri-file-text-line",
    title: "丰富详情",
    desc: "每部作品配有完整简介、演职人员与相关推荐，浏览体验更完整。",
  },
];

export default function SiteIntro() {
  const total = getAllVideos().length;

  return (
    <section className="w-full px-4 md:px-8 mt-14 md:mt-16">
      <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-label font-semibold">
              <i className="ri-movie-2-line" /> 关于芭乐视频
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              多元化高清视频内容聚合平台
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              芭乐视频面向热爱多元化高清视频内容的广大影视爱好者，聚合电影、电视剧、动漫等多种类别，
              以清晰的分类、灵活的筛选与丰富的详情展示，帮助用户便捷浏览、高效发现优质视听资源。
              无论你想追一部新剧、重温经典电影，还是发现一部宝藏动漫，都能在这里快速找到。
            </p>
            <div className="mt-6 flex flex-wrap gap-6">
              <div>
                <p className="font-heading text-2xl font-bold text-primary-600">{total}+</p>
                <p className="text-xs text-foreground-500 mt-1">在库影视作品</p>
              </div>
              <div>
                <p className="font-heading text-2xl font-bold text-primary-600">3</p>
                <p className="text-xs text-foreground-500 mt-1">核心内容频道</p>
              </div>
              <div>
                <p className="font-heading text-2xl font-bold text-primary-600">每日</p>
                <p className="text-xs text-foreground-500 mt-1">持续内容更新</p>
              </div>
            </div>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              了解更多 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {highlights.map((item) => (
              <div key={item.title} className="flex items-start gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70">
                <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-secondary-100 text-secondary-800 shrink-0">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}